<!--<div class="flex-1 px-6 mb-6">-->
<!--  <div class="min-h-[300px] space-y-4">-->
<!--    @for (message of messages$ | async; track message.id) {-->
<!--      <div class="flex" [class.justify-end]="message.sender === 'user'">-->
<div class="flex justify-end px-4 mt-2 mb-2">
  <div class="max-w-[80%] p-4 rounded-[10.4px] bg-[rgba(227,215,255,0.3)] border border-[rgba(221,185,253,1)] text-black">
    <p class="text-sm leading-relaxed">{{ data.message }}</p>
  </div>
</div>

<!--    }-->
<!--  </div>-->
<!--</div>-->